import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const navigate = useNavigate();
  const userType = localStorage.getItem('user_type');

  useEffect(() => {
    // if (userType === '8' || userType === 8 || userType === '6' || userType === 6) {
    //   navigate('/distributor-dashboard', { replace: true });
    // } else {
    //   navigate('/devices', { replace: true });
    // }
     navigate('/distributor-dashboard', { replace: true });
  }, [userType, navigate]);

  return null;
};

export default Home;
